"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStringsForExperience = exports.getStringsForExperience = void 0;
var merge = require("lodash.merge");
var _1 = require(".");
/**
 * Component utility for swapping strings based on experience
 *
 * ```
 * return (
 *   <ExperienceProvider>
 *     {({experience}) =>
 *       const ExperienceStrings =
 *         getStringsForExperience(LayoutStrings, experience)
 *       return <div>{ExperienceStrings.hero.heading()}</div>
 *     }
 *   </ExperienceProvider>
 * )
 * ```
 */
function getStringsForExperience(doorDashStrings, experience) {
    if (experience === _1.Experience.Caviar) {
        return merge(doorDashStrings, doorDashStrings.caviar);
    }
    if (experience === _1.Experience.Storefront) {
        return merge(doorDashStrings, doorDashStrings.storefront);
    }
    return doorDashStrings;
}
exports.getStringsForExperience = getStringsForExperience;
/**
 * Inline utility for swapping strings based on experience
 *
 * ```
 * const ExperienceStrings = useStringsForExperience(LayoutStrings)
 * return (
 *   <React.Fragment>
 *     {ExperienceStrings.hero.heading()}
 *   </React.Fragment>
 * )
 * ```
 */
function useStringsForExperience(doorDashStrings) {
    var experience = _1.useExperience().experience;
    return getStringsForExperience(doorDashStrings, experience);
}
exports.useStringsForExperience = useStringsForExperience;
